'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import DocumentTitle from '@uw-it-sis/lib-react/lib/DocumentTitle';
import classnames from 'classnames';
import moment from "moment";
import {Link} from "react-router-dom";
import {sortBy} from "underscore";

import {FaPrint} from "react-icons/fa";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import {getGeneralPlaceholderName} from "@uw-it-sis/lib-react-myplan/lib/GeneralPlaceHolderConstants";

import printViewStore from './PrintViewStore';
import ExtraordinaryCircumstances from "../common/ExtraordinaryCircumstances";

class PrintView extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = printViewStore;

        this.buildDoneComponent = this.buildDoneComponent.bind(this);
    }

    componentDidMount() {
        this.store.mount()
    }

    buildDoneComponent() {
        let planTerms = this.store.getPlanData().map((term, n) => {
            let academicRecordList, plannedList;

            if (term.hasOwnProperty("academicRecord") && term.academicRecord.length > 0) {
                let academicRecord = sortBy(term.academicRecord, "courseCode").map((item, i) => {
                    return (
                        <li className="d-flex" key={i}>
                            <span className="me-auto">{item.courseCode} ({item.credit})</span>
                            <span>{item.grade}</span>
                        </li>
                    );
                });

                academicRecordList =
                    <>
                        <small id="academic-record-list" className={classnames("d-block text-uppercase", {"sr-only": term.completedTerm})}>
                            <strong>{term.openForPlanning || term.currentTermForView ? "Registered" : "Completed"}</strong>
                        </small>
                        <ul aria-labelledby="academic-record-list" className="list-unstyled">{academicRecord}</ul>
                    </>;
            }

            if (term.hasOwnProperty("plannedList") && term.plannedList.length > 0 && term.openForPlanning) {
                let planned = term.plannedList.map((item, i) => {
                    let itemName;
                    if (item.hasOwnProperty("placeHolder") && item.placeHolder) {
                        let placeHolderName = getGeneralPlaceholderName(item.placeHolderCode, item.placeHolderValue);

                        let placeHolderPrefix = "";
                        if (item.planItemDataObject.refObjType === "uw.course.genedrequirement") {
                            placeHolderPrefix = "Gen Ed Req: ";
                        }

                        itemName = placeHolderPrefix + placeHolderName;
                    } else {
                        itemName = item.courseDetails.code;
                    }

                    return (
                        <li className="d-flex" key={i}>
                            <span className="me-auto">{itemName} {item.credit ? `(${item.credit})`:""}</span>
                        </li>
                    );
                });

                plannedList =
                    <>
                        <small id="planned-list" className="d-block text-uppercase"><strong>Planned</strong></small>
                        <ul aria-labelledby="planned-list" className="list-unstyled">{planned}</ul>
                    </>;
            }

            return (
                <Col xs={3} as="li" aria-labelledby={`planned-term-${term.atpId}`} key={n} className="d-flex align-items-start flex-column border-end">
                    <div className="w-100">
                        <Row className="bg-light-gray border-top border-bottom py-1">
                            <Col xs={12} className="fw-bold lead" id={`planned-term-${term.atpId}`}>{term.qtrYear}</Col>
                            <Col xs={12}><ExtraordinaryCircumstances termId={term.atpId} /></Col>
                        </Row>

                    </div>
                    <div className="w-100 pt-2" style={{minHeight: "7rem"}}>
                        {academicRecordList}
                        {plannedList}
                    </div>
                    <div className="w-100 mt-auto">
                        <Row className="border-dotted border-top border-end-0 border-start-0 border-bottom-0 py-1">
                            <Col className="text-end"><small>Credits: {term.credits}</small></Col>
                        </Row>
                    </div>
                </Col>
            );
        });

        /*
        // Leaving in case student number display needs to return
        let studentNumber = appStore.getStudentNumber();
        if (studentNumber) {
            studentNumber = `(${studentNumber})`
        } else {
            studentNumber = "(No student number)";
        }
        */

        return (
            <>
                <div className="page-heading d-flex align-items-end justify-content-between">
                    <div>
                        <Link to={'/'} className="d-print-none d-block mb-2">Back to current academic year view</Link>
                        <h1 className="d-block">Entire Academic Plan and History</h1>
                    </div>
                    <Button variant="icon-link" onClick={() => window.print()} size="sm" className="d-print-none">
                        <FaPrint className="me-2" aria-hidden="true"/>
                        Print
                    </Button>
                </div>
                <Row className="mx-0 py-3 border-top border-bottom g-0">
                    <Col xs={12} md={6} lg={4}><strong>Date Prepared: {moment(appStore.getNow()).format("L - LT")}</strong></Col>
                    <Col xs={12} md={6} lg={4}><strong>Prepared for: {appStore.getDisplayName()}</strong></Col>
                </Row>
                <div>
                    <p className="mt-3">This is not a UW transcript and does not reflect credit earned transfer work, or AP/IB/CBE credit.</p>
                </div>
                <Row className="align-content-stretch mt-4 mx-0 mb-3 border-start border-bottom avoid-break-inside list-unstyled" as="ul">
                    {planTerms}
                </Row>
                <div>
                    <p>Any alteration, modification, or misrepresentation of this planning tool or any copy thereof may constitute a felony and/or lead to student disciplinary sanctions.</p>
                </div>
            </>
        );
    }

    render() {
        return (
            <DocumentTitle title={`${appStore.getDisplayName()} - MyPlan`}>
                <SimpleState state={this.store.state}
                             doneComponentBuilder={this.buildDoneComponent}
                             pendingComponentBuilder="dots"
                             name="PrintView" />
            </DocumentTitle>
        );
    }
}

export default observer(PrintView);